import { render, staticRenderFns } from "@/components/Layout/Administracion/Cargar_archivos/Cargar_archivos.html?vue&type=template&id=4fcbfd89&scoped=true&"
import script from "@/components/Layout/Administracion/Cargar_archivos/Cargar_archivos.js?vue&type=script&lang=js&"
export * from "@/components/Layout/Administracion/Cargar_archivos/Cargar_archivos.js?vue&type=script&lang=js&"
import style0 from "@/components/Layout/Administracion/Cargar_archivos/Cargar_archivos.css?vue&type=style&index=0&id=4fcbfd89&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fcbfd89",
  null
  
)

export default component.exports